export default __webpack_public_path__ + "static/media/logo.1d517287.svg";